// extracted by mini-css-extract-plugin
module.exports =  {"container":"ATaIozoc3weY1cmHwdBi","registerHeader":"TdhIzhvco0yKJOJP0RUU","creabotsLabel":"r9p7TbaVlnQ3XoVk2nJ7","registerLaterBtn":"ggGI9qgyyrhSK86NnVoB"};